import React, { useState, useEffect, useRef } from "react";
import NavigationButtons from "../../../Common/CommonButtons/NavigationButtons";
import ActionButtonGroup from "../../../Common/CommonButtons/ActionButtonGroup";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import "./TransferAdjustments.css";
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import CompanyMasterHelp from "../../../Helper/CompanyMasterHelper";
import GSTRateMasterHelp from "../../../Helper/GSTRateMasterHelp";
import UserAuditInfo from "../../../Common/UserAuditInfo/UserAuditInfo";
import { TextField, Grid, Box, Card, CardContent, Button } from '@mui/material';
import Swal from "sweetalert2";
import TransferAdjustmentHelp from "../../../Helper/TransferAdjusmentHelp";
import SaveUpdateSpinner from "../../../Common/Spinners/SaveUpdateSpinner";
import { validateDocumentDate } from "../../../Common/ValidateDateRange/ValidateDateRange";
import CheckReportFormMultiplecompanyentries from "./MultipleCompanyEntrieschequeprint";

const API_URL = process.env.REACT_APP_API;

//Labels Global variables
var ToName = "";
var ToCode = "";
var FromName = "";
var FromCode = "";
var GStrateCode = "";
var GStrateName = "";
var selectedfilter = "";
var CompanyName = "";
var CompanyCode = "";
var CrossFromName = "";
var CrossFromCode = "";
var CrossToName = "";
var CrossToCode = "";

const CompanyEntries = () => {
  const location = useLocation();
  selectedfilter = location.state?.selectedfilter;
  const inputRef = useRef(null);

  const Year_Code = sessionStorage.getItem("Year_Code");
  const company_code = sessionStorage.getItem("Company_Code");
  const searchParams = new URLSearchParams(location.search);
  const navigatedRecord = searchParams.get('navigatedRecord');

  const [updateButtonClicked, setUpdateButtonClicked] = useState(false);
  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const [addOneButtonEnabled, setAddOneButtonEnabled] = useState(false);
  const [saveButtonEnabled, setSaveButtonEnabled] = useState(true);
  const [cancelButtonEnabled, setCancelButtonEnabled] = useState(true);
  const [editButtonEnabled, setEditButtonEnabled] = useState(false);
  const [deleteButtonEnabled, setDeleteButtonEnabled] = useState(false);
  const [backButtonEnabled, setBackButtonEnabled] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [highlightedButton, setHighlightedButton] = useState(null);
  const [cancelButtonClicked, setCancelButtonClicked] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [SystemType, setSystemType] = useState(selectedfilter);
  const [toAccount, setToAccount] = useState("");
  const [fromAccount, setFromAccount] = useState("");
  const [crosstoaccount, setCrossToAccount] = useState("");
  const [crossfromaccount, setCrossFromAccount] = useState("");
  const [gstRateCode, setgstRateCode] = useState("");
  const [isHandleChange, setIsHandleChange] = useState(false);
  const [companycode, setCompanyCode] = useState("");
  const [companycodename, setCompanyCodeName] = useState("");
  const [crosscompanycode, setCrossCompanyCode] = useState("");
  const [crosscompanyname, setCrossCompanyName] = useState("");
  const companyCode = sessionStorage.getItem("Company_Code");
  const username = sessionStorage.getItem("username");
  const [accountCode, setAccountCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [resetKey, setResetKey] = useState(0);
  const [crossResetKey, setCrossResetKey] = useState(0);


  const labelStyle = {
    fontSize: "0.8125rem",
    fontWeight: 600,
    color: "#374151",
    minWidth: "140px",
    whiteSpace: "nowrap",
  };

  const selectedRecord = location.state?.selectedRecord;
  const permissions = location.state?.permissionsData;

  const initialFormData = {
    CompanyCode: "",
    CrossCompany: "",
    CrossFromAcc: "",
    CrossToAcc: "",
    FromAcc: "",
    ToAcc: "",
    Amount: "",
    cheque_no: "",
    Narration: "",
    Modified_By: "",
    Created_By: "",
    Year_Code: Year_Code,
    Date: new Date().toISOString().split("T")[0],
    TransferId: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (isHandleChange) {
      handleCancel();
      setIsHandleChange(false);
    }
    // document.getElementById("System_Name_E").focus();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "System_Type") {
      setSystemType(value);
      setIsHandleChange(true);
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };


  const fetchLastRecordSystemCode = () => {

    fetch(
      `${API_URL}/get-CompanyEntries-lastRecord?Id=${formData.Id}`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch last record");
        }
        return response.json();
      })
      .then((data) => {
        const last = data?.last_MultipleCompanyEntries_data;

        // If we have a valid System_Code, increment it, otherwise start from 1
        const nextCode =
          last && last.Id != null && !isNaN(Number(last.Id))
            ? Number(last.Id) + 1
            : 1;

        setFormData((prevState) => ({
          ...prevState,
          Id: nextCode,
        }));
      })
      .catch((error) => {
        console.error("Error fetching last record:", error);
        // On error you can also choose to default to 1 if you want:
        setFormData((prevState) => ({
          ...prevState,
          Id: 1,
        }));
      });
  };





  const handleAddOne = () => {
    setAddOneButtonEnabled(false);
    setSaveButtonEnabled(true);
    setCancelButtonEnabled(true);
    setEditButtonEnabled(false);
    setDeleteButtonEnabled(false);
    setIsEditing(true);

    fetchLastRecordSystemCode();

    ToName = "";
    ToCode = "";
    FromName = "";
    FromCode = "";
    GStrateCode = "";
    GStrateName = "";
    selectedfilter = "";
    CompanyName = "";
    CompanyCode = "";
    CrossFromName = "";
    CrossFromCode = "";
    CrossToName = "";
    CrossToCode = "";




    resetAccountFields();
    setCompanyCode("");
    setCompanyCodeName("");
    setCrossCompanyCode("");
    setCrossCompanyName("");
    setToAccount("");
    setFromAccount("");
    setCrossToAccount("");
    setCrossFromAccount("");

    setFormData((prev) => ({
      ...prev,
      CrossCompany: "",
      CompanyCode: "",
      CrossToAcc: "",
      CrossFromAcc: "",
      ToAcc: "",
      FromAcc: "",
      TransferId: "",
    }));

    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };



  // const handleSaveOrUpdate = async () => {
  //         debugger
  //         const Post_Date = sessionStorage.getItem("Post_Date");
  //         const Outword_Date = sessionStorage.getItem("Outword_Date")
  //         // if (await OutwordPostDateRecordLock(formData.Doc_Date, Post_Date, Outword_Date)) {
  //         //     return;
  //         // }

  //         const accountingYearData = sessionStorage.getItem("Accounting_Year");
  //         const formattedEntryDate = formData.Doc_Date;
  //         // const isValid = validateDocumentDate(
  //         //     formattedEntryDate,
  //         //     accountingYearData
  //         // );

  //         // if (!isValid) {
  //         //     return;
  //         // }

  //         if (!formData.Amount || Number(formData.Amount) === 0) {
  //             Swal.fire({
  //                 title: "Invalid Advance Amount",
  //                 text: "Advance amount cannot be 0. Please enter a valid amount.",
  //                 icon: "warning",
  //                 confirmButtonText: "OK"
  //             });
  //             setIsLoading(false);
  //             return;
  //         }
  //         // if (!formData.Cash_Bank_Ac || Number(formData.Cash_Bank_Ac) === 0) {
  //         //     Swal.fire({
  //         //         title: "Fill Cash Bank",
  //         //         text: "Cash Bank A/C cannot be Empty.",
  //         //         icon: "warning",
  //         //         confirmButtonText: "OK"
  //         //     });
  //         //     setIsLoading(false);
  //         //     return;
  //         // }
  //         setIsEditing(true);
  //         setIsLoading(true);

  //         // if (awakChanged && formData.Ac_Code !== framer) {
  //         //     Swal.fire({
  //         //         title: "Farmer Mismatch!",
  //         //         text: "Selected Farmer does not match the Farmer linked with this Awak No.",
  //         //         icon: "error",
  //         //         confirmButtonText: "OK"
  //         //     });
  //         //     setIsLoading(false);
  //         //     return;  // ❌ Stop Save/Update
  //         // }
  //         if (isEditMode) {
  //             const responseData = {
  //                 ...formData,
  //                 Modified_By: username
  //             }
  //             axios
  //                 .put(
  //                     `${API_URL}/update-CompanyEntries`,
  //                     responseData
  //                 )
  //                 .then((response) => {
  //                     Swal.fire({
  //                         title: "Success!",
  //                         text: "Record updated successfully!",
  //                         icon: "success",
  //                         confirmButtonText: "OK"
  //                     });
  //                     setIsEditMode(false);
  //                     setAddOneButtonEnabled(true);
  //                     setEditButtonEnabled(true);
  //                     setDeleteButtonEnabled(true);
  //                     setBackButtonEnabled(true);
  //                     setSaveButtonEnabled(false);
  //                     setCancelButtonEnabled(false);
  //                     setUpdateButtonClicked(true);
  //                     setIsEditing(false);
  //                 })
  //                 .catch((error) => {
  //                     handleCancel();
  //                     console.error("Error updating data:", error);
  //                 })
  //                 .finally(() => {
  //                     setIsLoading(false); // Stop spinner
  //                 });
  //         } else {
  //             const responseData = {
  //                 ...formData,
  //                 Created_By: username
  //             }
  //             console.log(responseData)
  //             axios
  //                 .post(
  //                     `${API_URL}/create-Record-CompanyEntries`,
  //                     responseData
  //                 )
  //                 .then((response) => {
  //                     Swal.fire({
  //                         title: "Success!",
  //                         text: "Record Created successfully!",
  //                         icon: "success",
  //                         confirmButtonText: "OK"
  //                     });
  //                     setIsEditMode(false);
  //                     setAddOneButtonEnabled(true);
  //                     setEditButtonEnabled(true);
  //                     setDeleteButtonEnabled(true);
  //                     setBackButtonEnabled(true);
  //                     setSaveButtonEnabled(false);
  //                     setCancelButtonEnabled(false);
  //                     setUpdateButtonClicked(true);
  //                     setIsEditing(false);

  //                     setTimeout(() => {
  //                         window.location.reload();
  //                     }, 1000);
  //                     navigate(`/companyentries-api?navigatedRecord=${formData.Doc_No}`);
  //                 })
  //                 .catch((error) => {
  //                     console.error("Error saving data:", error);
  //                 })
  //                 .finally(() => {
  //                     setIsLoading(false); // Stop spinner
  //                 });
  //         }
  //     };


  const handleSaveOrUpdate = async () => {
    
    const accountingYearData = sessionStorage.getItem("Accounting_Year");
    const formattedEntryDate = formData.Date;
    const isValid = validateDocumentDate(
      formattedEntryDate,
      accountingYearData
    );

    if (!isValid) {
      return;
    }
    if (!formData.Amount || Number(formData.Amount) === 0) {
      Swal.fire({
        title: "Invalid Amount",
        text: "Amount cannot be 0.",
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }

    setIsEditing(true);
    setIsLoading(true);   // ← START loader

    try {
      if (isEditMode) {
        const responseData = { ...formData, Modified_By: username };
        await axios.put(`${API_URL}/update-CompanyEntries`, responseData);

        Swal.fire({ title: "Success!", text: "Record updated successfully!", icon: "success", confirmButtonText: "OK" });
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setUpdateButtonClicked(true);
        setIsEditing(false);

      } else {
        const responseData = { ...formData, Created_By: username };
        await axios.post(`${API_URL}/create-Record-CompanyEntries`, responseData);

        Swal.fire({ title: "Success!", text: "Record Created successfully!", icon: "success", confirmButtonText: "OK" });
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setUpdateButtonClicked(true);
        setIsEditing(false);

        setTimeout(() => window.location.reload(), 1000);
        navigate(`/companyentries-api?navigatedRecord=${formData.Id}`);
      }
    } catch (error) {
      console.error("Error saving/updating data:", error);
      toast.error("Error occurred while saving data");
    } finally {
      setIsLoading(false);   // ← STOP loader always
    }
  };


  const handleEdit = () => {
    setIsEditMode(true);
    setAddOneButtonEnabled(false);
    setSaveButtonEnabled(true);
    setCancelButtonEnabled(true);
    setEditButtonEnabled(false);
    setDeleteButtonEnabled(false);
    setBackButtonEnabled(true);
    setIsEditing(true);
  };

  const handleCancel = () => {
    axios
      .get(
        `${API_URL}/get-CompanyEntries-lastRecord?Id=${formData.Id}`
      )
      .then((response) => {
        const data = response.data;
        const labels = data.labels;
        if (data && data.last_MultipleCompanyEntries_data) {
          ToName = data.labels.TOACCNAME;
          ToCode = data.last_MultipleCompanyEntries_data.ToAcc;
          FromName = data.labels.FromACCNAME;
          FromCode = data.last_MultipleCompanyEntries_data.FromAcc;
          CrossToName = data.labels.CrossToACCNAME;
          CrossToCode = data.last_MultipleCompanyEntries_data.CrossToAcc;
          CrossFromName = data.labels.CrossFromACCName;
          CrossFromCode = data.last_MultipleCompanyEntries_data.CrossFromAcc;
          CompanyName = data.labels.Company_Name_E;
          setCompanyCode(data.last_MultipleCompanyEntries_data.CompanyCode || "");
          setCompanyCodeName(data.labels.Company_Name_E || "");
          setCrossCompanyName(data.labels.CrossCompanyname || "");
          setCrossCompanyCode(data.last_MultipleCompanyEntries_data.CrossCompany || "");
          GStrateName = data.labels.GST_Name;
          GStrateCode = data.last_MultipleCompanyEntries_data.Gst_Code;
          setFormData({
            ...formData,
            ...data.last_MultipleCompanyEntries_data,
          });
        } else {
          console.error("No data found for the specified SystemType");
        }
      })
      .catch((error) => {
        console.error("Error fetching latest data for edit:", error);
      });
    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setCancelButtonClicked(true);
  };

  const handleDelete = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `You want to delete Id: ${formData.Id}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      cancelButtonText: "Cancel",
      confirmButtonText: "Yes, Delete",
      reverseButtons: true,
      focusCancel: true,
    });

    if (result.isConfirmed) {
      // Update UI state
      setIsEditMode(false);
      setAddOneButtonEnabled(true);
      setEditButtonEnabled(true);
      setDeleteButtonEnabled(true);
      setBackButtonEnabled(true);
      setSaveButtonEnabled(false);
      setCancelButtonEnabled(false);
      setIsLoading(true);

      try {
        const deleteApiUrl = `${API_URL}/delete-CompanyEntries?Id=${formData.Id}`;
        const response = await axios.delete(deleteApiUrl);

        Swal.fire({
          title: "Deleted!",
          text: "Record deleted successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });

        handleCancel();
      } catch (error) {
        toast.error("Something went wrong!");
        console.error("Error during API call:", error);
      }
      finally {
        setIsLoading(false);   // ← ADD THIS
      }
    } else {
      Swal.fire({
        title: "Cancelled",
        text: "Your record is safe 🙂",
        icon: "info",
      });
    }
  };

  const handleBack = () => {
    navigate("/company-entry-utility");
  };


  const fetchCompanyentriesData = async (url, dataKey) => {
    try {
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();
        const systemData = data[dataKey];

        if (!systemData) {
          console.error("No data found for key:", dataKey);
          return;
        }


        ToName = data.labels.TOACCNAME || "";
        ToCode = systemData.ToAcc || "";
        FromName = data.labels.FromACCNAME || "";
        FromCode = systemData.FromAcc || "";
        CrossToName = data.labels.CrossToACCNAME || "";
        CrossToCode = systemData.CrossToAcc || "";
        CrossFromName = data.labels.CrossFromACCName || "";
        CrossFromCode = systemData.CrossFromAcc || "";

        // ── Set state ──
        setCompanyCode(systemData.CompanyCode || "");
        setCompanyCodeName(data.labels.Company_Name_E || "");
        setCrossCompanyName(data.labels.CrossCompanyname || "");
        setCrossCompanyCode(systemData.CrossCompany || "");



        setFormData((prev) => ({
          ...prev,
          ...systemData,
        }));

      } else {
        console.error("Failed to fetch data:", response.status, response.statusText);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleNavigateRecord = async () => {
    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);

    const url = `${API_URL}/get-CompanyEntriesSelectedRecord?Id=${navigatedRecord}`;
    await fetchCompanyentriesData(url, "selected_Record_data");
  };

  useEffect(() => {
    if (selectedRecord) {
      handlerecordDoubleClicked();
    }
    else if (navigatedRecord && !isNaN(navigatedRecord) && parseInt(navigatedRecord) > 0) {
      handleNavigateRecord();
    }
    else {
      handleAddOne();
    }
  }, [selectedRecord, navigatedRecord]);

  const handleFirstButtonClick = async () => {
    const url = `${API_URL}/get-first-CompanyEntries`;
    await fetchCompanyentriesData(url, "first_MultipleCompanyEntries_data");
  };

  const handlePreviousButtonClick = async () => {
    const url = `${API_URL}/get-previous-CompanyEntries?Id=${formData.Id}`;
    await fetchCompanyentriesData(url, "previous_MultipleCompanyEntries_data");
  };

  const handleNextButtonClick = async () => {
    const url = `${API_URL}/get-next-CompanyEntries?Id=${formData.Id}`;
    await fetchCompanyentriesData(url, "next_MultipleCompanyEntries_data");
  };

  const handleLastButtonClick = async () => {
    const url = `${API_URL}/get-CompanyEntries-lastRecord?Id=${formData.Id}`;
    await fetchCompanyentriesData(url, "last_MultipleCompanyEntries_data");
  };

  const handlerecordDoubleClicked = async () => {
    const url = `${API_URL}/get-CompanyEntriesSelectedRecord?Id=${selectedRecord.Id}`;
    await fetchCompanyentriesData(url, "selected_Record_data");

    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setUpdateButtonClicked(true);
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Tab") {
      const changeNoValue = event.target.value;
      const url = `${API_URL}/get-CompanyEntriesSelectedRecord?Id=${changeNoValue}`;
      await fetchCompanyentriesData(url, "selected_Record_data");
      setIsEditing(false);
    }
  };

  const resetAccountFields = () => {
    // Global variables
    ToName = "";
    ToCode = "";
    FromName = "";
    FromCode = "";
    CrossToName = "";
    CrossToCode = "";
    CrossFromName = "";
    CrossFromCode = "";

    // Local states
    setToAccount("");
    setFromAccount("");
    setCrossToAccount("");
    setCrossFromAccount("");

    // Clear formData values
    setFormData((prev) => ({
      ...prev,
      ToAcc: "",
      FromAcc: "",
      CrossToAcc: "",
      CrossFromAcc: "",
      Amount: "",
      Narration: "",
      cheque_no: "",
      CompanyCode: "",
      CrossCompany: "",
    }));
  };



  const handleCompanyCode = (code, name) => {
    setCompanyCode(code);
    setCompanyCodeName(name);

    ToName = ""; ToCode = "";
    FromName = ""; FromCode = "";
    CrossToName = ""; CrossToCode = "";
    CrossFromName = ""; CrossFromCode = "";

    setCrossCompanyCode("");
    setCrossCompanyName("");
    setCompanyCode("");
    setCompanyCodeName("");
    setToAccount("");
    setFromAccount("");
    setCrossToAccount("");
    setCrossFromAccount("");

    setResetKey(prev => prev + 1);       // resets TO, FROM
    setCrossResetKey(prev => prev + 1);  // resets Cross Company, CrossTO, CrossFROM

    setFormData((prev) => ({
      ...prev,
      CompanyCode: code || "",
      CrossCompany: "",
      ToAcc: "",
      FromAcc: "",
      CrossToAcc: "",
      CrossFromAcc: "",
    }));
  };

  const handleCrossCompanyCode = (code, name) => {

    if (code && formData.CompanyCode && code === formData.CompanyCode) {
      Swal.fire({
        title: "Validation Error!",
        text: "Cross Company Code cannot be the same as Company Code.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return; // Don't set the value
    }
    setCrossCompanyCode(code || "");
    setCrossCompanyName(name || "");

    CrossToName = ""; CrossToCode = "";
    CrossFromName = ""; CrossFromCode = "";

    setCrossToAccount("");
    setCrossFromAccount("");

    setCrossResetKey(prev => prev + 1);  // only resets cross fields

    setFormData((prev) => ({
      ...prev,
      CrossCompany: code || "",
      CrossToAcc: "",
      CrossFromAcc: "",
    }));
  };


  const handleGstRateCode = (code) => {
    setgstRateCode(code);
    setFormData({
      ...formData,
      Gst_Code: code,
    });
  };

  const handleAccountCodeChange = (key, code) => {
    setAccountCode(code);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [key]: code,
    }));
  };

  //Handle individual function to manage the account master

  // const handleToAccount = (code) =>
  //   handleAccountCodeChange("ToAcc", code);

  //   const handleToAccount = async (code) => {
  //   handleAccountCodeChange("ToAcc", code);

  //   try {
  //     const response = await axios.get(
  //       `${API_URL}/getalldata-fromTransferAdj`,
  //       {
  //         params: {
  //           CompanyCode: formData.CompanyCode,
  //           To_accid: code,
  //         },
  //       }
  //     );

  //     const data = response.data?.all_data;

  //     if (data && data.length > 0) {
  //       const row = data[0];

  //       // FROM A/C
  //       FromName = row.FromACName || "";
  //       FromCode = row.From_accid || "";

  //       // CROSS COMPANY
  //       setCrossCompanyCode(row.CrossCompanyCode || "");
  //       setCrossCompanyName(row.CrossCompanyName || "");

  //       // CROSS TO
  //       CrossToName = row.CrossToACName || "";
  //       CrossToCode = row.CrossTo_acc || "";

  //       // CROSS FROM
  //       CrossFromName = row.CrossFromAcc || "";
  //       CrossFromCode = row.CrossFrom_acc || "";

  //       // FORM DATA
  //       setFormData((prev) => ({
  //         ...prev,
  //         ToAcc: code || "",
  //         FromAcc: row.From_accid || "",
  //         CrossCompany: row.CrossCompanyCode || "",
  //         CrossToAcc: row.CrossTo_acc || "",
  //         CrossFromAcc: row.CrossFrom_acc || "",
  //       }));
  //     } else {
  //       // CLEAR ALL FIELDS

  //       FromName = "";
  //       FromCode = "";

  //       CrossToName = "";
  //       CrossToCode = "";

  //       CrossFromName = "";
  //       CrossFromCode = "";

  //       setCrossCompanyCode("");
  //       setCrossCompanyName("");

  //       setFormData((prev) => ({
  //         ...prev,
  //         ToAcc: code || "",
  //         FromAcc: "",
  //         CrossCompany: "",
  //         CrossToAcc: "",
  //         CrossFromAcc: "",
  //       }));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching transfer adjustment data:", error);

  //     // ALSO CLEAR ON ERROR

  //     FromName = "";
  //     FromCode = "";

  //     CrossToName = "";
  //     CrossToCode = "";

  //     CrossFromName = "";
  //     CrossFromCode = "";

  //     setCrossCompanyCode("");
  //     setCrossCompanyName("");

  //     setFormData((prev) => ({
  //       ...prev,
  //       FromAcc: "",
  //       CrossCompany: "",
  //       CrossToAcc: "",
  //       CrossFromAcc: "",
  //     }));
  //   }
  // };


  const handleTransferId = (item) => {
    if (!item) {
      ToName = "";
      ToCode = "";
      FromName = "";
      FromCode = "";
      CrossToName = "";
      CrossToCode = "";
      CrossFromName = "";
      CrossFromCode = "";
      setCrossCompanyCode("");
      setCrossCompanyName("");
      setFormData((prev) => ({
        ...prev,
        TransferId: "",
        ToAcc: "",
        FromAcc: "",
        CrossCompany: "",
        CrossToAcc: "",
        CrossFromAcc: "",
      }));
      return;
    }

    // TRANSFER ID
    handleAccountCodeChange("TransferId", item.Id);

    // TO A/C ← was missing before
    ToName = item.ToACName || "";
    ToCode = item.To_accid || "";

    // FROM A/C
    FromName = item.FromACName || "";
    FromCode = item.From_accid || "";

    // CROSS COMPANY
    setCrossCompanyCode(item.CrossCompanyCode || "");
    setCrossCompanyName(item.CrossCompanyName || "");

    // CROSS TO
    CrossToName = item.CrossToACName || "";
    CrossToCode = item.CrossTo_acc || "";

    // CROSS FROM
    CrossFromName = item.CrossFromAcc || "";
    CrossFromCode = item.CrossFrom_acc || "";

    setFormData((prev) => ({
      ...prev,
      TransferId: item.Id || "",
      ToAcc: item.To_accid || "",  // ← now included
      FromAcc: item.From_accid || "",
      CrossCompany: item.CrossCompanyCode || "",
      CrossToAcc: item.CrossTo_acc || "",
      CrossFromAcc: item.CrossFrom_acc || "",
    }));
  };
  const handleToAccount = (code) => handleAccountCodeChange("ToAcc", code);
  const handleFromAccount = (code) =>
    handleAccountCodeChange("FromAcc", code);
  const handlCrossToAccount = (code) =>
    handleAccountCodeChange("CrossToAcc", code);
  const handlCrossFromAccount = (code) =>
    handleAccountCodeChange("CrossFromAcc", code);


  const handleTransferToRTGS = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/TransferDataTo-RTGS-FromCompanyEntries`,
        {
          params: {
            CompanyCode: companyCode,
            Year_Code: Year_Code,
            Id: formData.Id
          }
        }
      );

      const data = res.data.all_data[0];

      // const { bank, acNo, branch } = parseBankDetail(data.bankdetail);

      const rtgsFormData = {
        // Ac_code: data.credit_ac,
        // Ac: data.ca,

        // Party_name: data.CreditAcName?.trim(),
        // Party_Bank: data.Bank_Name?.trim(),
        // Party_Branch: data.Branch?.trim(),
        // Party_Ac_No: data.Bank_Ac_No?.trim(),
        // Ifsc: data.IFSC,

        // Amount: parseFloat(data.amount),

        // Bank_Code: data.cashbank,
        // bc: data.cb,

        // // Our_Bank: data.CASHBANKNAME?.trim(),
        // Our_Bank: bank?.trim() || data.CASHBANK_Name,
        // Our_Branch: branch?.trim() | data.CASHBANKBranch,
        // Our_AC_No: acNo?.trim() || data.CASHBANK_Ac_No,

        // cheque_No: data.narration,

        // Company_Code: data.company_code,
        // Year_Code: data.year_code


        Ac_code: data.ToAcc,
        Ac: data.accoid,
        Bank_Code: data.FromAcc,
        Bank_Name: data.Bank_Name,
        Party_name: data.RTGSPARTYNAME?.trim(),
        Party_Bank: data.PartyBank_Name?.trim(),
        Party_Branch: data.Partybranch?.trim(),
        Party_Ac_No: data.PartyBank_Ac_No?.trim(),
        Ifsc: data.PartyIFSC,
        Amount: parseFloat(data.Amount),
        Our_Bank: data.Bank_Name?.trim(),
        Our_Branch: data.Branch?.trim(),
        Our_AC_No: data.Bank_Ac_No?.trim(),
        cheque_No: data.cheque_no,

        // Total: parseFloat(data.Advance),
        Company_Code: data.CompanyCode,
        // Year_Code: data.year_code,
      };

      navigate("/rtgs-form", { state: rtgsFormData });

    } catch (error) {
      console.error(error);
      alert("Failed to transfer data to RTGS");
    }
  };

  return (
    <>

      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner-container">
            <SaveUpdateSpinner />
          </div>
        </div>
      )}
      <UserAuditInfo
        createdBy={formData.Created_By}
        modifiedBy={formData.Modified_By}
        title={"Multiple Company Entries"}
      />

      {/* ── Action + Navigation bar ── */}
      <div style={{ marginTop: "30px" }}>
        <ToastContainer autoClose={500} />
        <ActionButtonGroup
          handleAddOne={handleAddOne}
          addOneButtonEnabled={addOneButtonEnabled}
          handleSaveOrUpdate={handleSaveOrUpdate}
          saveButtonEnabled={saveButtonEnabled}
          isEditMode={isEditMode}
          handleEdit={handleEdit}
          editButtonEnabled={editButtonEnabled}
          handleDelete={handleDelete}
          deleteButtonEnabled={deleteButtonEnabled}
          handleCancel={handleCancel}
          cancelButtonEnabled={cancelButtonEnabled}
          handleBack={handleBack}
          backButtonEnabled={backButtonEnabled}
          permissions={permissions}
          component={<div style={{ display: 'flex' }} >
            <CheckReportFormMultiplecompanyentries Id={formData.Id} disabledFeild={!addOneButtonEnabled} />
            <Button
              variant="contained"
              color="primary"
              style={{ marginLeft: "10px" }}
              onClick={handleTransferToRTGS}
              disabled={!addOneButtonEnabled}
            >
              Transfer To RTGS
            </Button>
          </div>}
        />
        <div>
          <NavigationButtons
            handleFirstButtonClick={handleFirstButtonClick}
            handlePreviousButtonClick={handlePreviousButtonClick}
            handleNextButtonClick={handleNextButtonClick}
            handleLastButtonClick={handleLastButtonClick}
            highlightedButton={highlightedButton}
            isEditing={isEditing}
            isFirstRecord={formData.Company_Code === 1}
          />
        </div>
      </div>

      {/* ── Main form card ── */}
      <div style={{ maxWidth: "1050px", margin: "20px auto 0", padding: "0 16px", marginBottom: "60px" }}>
        <form>
          <div
            style={{
              background: "#ffffff",
              borderRadius: "10px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
              padding: "24px 28px",
            }}
          >

            {/* ── Row: Change No + Date + ID ── */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-end",
                gap: "16px",
                marginBottom: "18px",
                flexWrap: "nowrap",
              }}
            >
              {/* Change No */}
              <div style={{ width: "130px", flexShrink: 0 }}>
                <label htmlFor="changeNo" style={{ ...labelStyle, display: "block", marginBottom: "4px" }}>
                  Change No
                </label>
                <input
                  type="text"
                  id="changeNo"
                  name="changeNo"
                  autoComplete="off"
                  onKeyDown={handleKeyDown}
                  disabled={!addOneButtonEnabled}
                  style={{
                    width: "100%",
                    padding: "7px 10px",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "0.8125rem",
                    outline: "none",
                    boxSizing: "border-box",
                    background: !addOneButtonEnabled ? "#f3f4f6" : "#fff",
                  }}
                />
              </div>

              {/* Date */}
              <div style={{ width: "160px", flexShrink: 0 }}>
                <label htmlFor="Date" style={{ ...labelStyle, display: "block", marginBottom: "4px" }}>
                  Date
                </label>
                <TextField
                  inputRef={inputRef}
                  type="date"
                  label="Date"
                  variant="outlined"
                  name="Date"
                  value={formData.Date || ""}
                  onChange={handleChange}
                  disabled={!isEditing && addOneButtonEnabled}
                  size="small"
                  InputLabelProps={{ shrink: true, style: { fontSize: "14px" } }}
                  InputProps={{ style: { fontSize: "12px", height: "40px" } }}
                  style={{ width: "100%" }}
                />
              </div>

              {/* ID (auto-generated) */}
              <div style={{ width: "160px", flexShrink: 0 }}>
                <label htmlFor="Id" style={{ ...labelStyle, display: "block", marginBottom: "4px" }}>
                  ID&nbsp;
                  <span style={{ fontWeight: 400, fontSize: "0.75rem", color: "#9ca3af" }}>(Auto-generated)</span>
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    id="Id"
                    name="Id"
                    value={formData.Id || ""}
                    onChange={handleChange}
                    disabled
                    style={{
                      width: "100%",
                      padding: "7px 32px 7px 10px",
                      border: "1px solid #d1d5db",
                      borderRadius: "6px",
                      fontSize: "0.8125rem",
                      background: "#f3f4f6",
                      color: "#6b7280",
                      boxSizing: "border-box",
                    }}
                  />
                  <svg
                    style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", width: "16px", height: "16px", color: "#9ca3af", pointerEvents: "none" }}
                    fill="currentColor" viewBox="0 0 20 20"
                  >
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
            </div>

            {/* ── Divider: Company section ── */}
            <SectionDivider label="Company Details" />

            {/* Company Code */}
            <FormRow label="Company Code">
              <CompanyMasterHelp
                onAcCodeClick={handleCompanyCode}
                CompanyName={companycodename}
                CompanyCode={formData.CompanyCode}
                name="CompanyCode"
                Ac_type={[]}
                disabledFeild={!isEditing || isEditMode}
              />
            </FormRow>


            <FormRow label="Transfer ID" style={{ gap: "28px", }}>
              <TransferAdjustmentHelp
                key={`transfer-${resetKey}`}
                onRecordClick={handleTransferId}
                // recordDisplay={ToName}
                recordId={formData.TransferId}
                name="TransferId"
                Company_Code={formData.CompanyCode}
                disabledField={!isEditing || isEditMode}
              />
            </FormRow>

            {/* TO A/c */}
            <FormRow label="Company Name" style={{ gap: "55px", }}>
              <AccountMasterHelp
                key={`to-${resetKey}`}
                onAcCodeClick={handleToAccount}
                CategoryName={ToName}
                CategoryCode={ToCode}
                name="ToAcc"
                Company_Code={formData.CompanyCode}
                Ac_type={[]}
                disabledFeild={!isEditing || isEditMode}
              />
            </FormRow>

            {/* FROM A/c */}
            <FormRow label="Company Bank" style={{ gap: "41px", }}>
              <AccountMasterHelp
                key={`from-${resetKey}`}
                onAcCodeClick={handleFromAccount}
                CategoryName={FromName}
                CategoryCode={FromCode}
                name="FromAcc"
                Ac_type={[]}
                Company_Code={formData.CompanyCode}
                disabledFeild={!isEditing || isEditMode}
              />
            </FormRow>

            {/* ── Divider: Transaction ── */}
            <SectionDivider label="Transaction" />

            {/* Amount */}
            <FormRow label="Amount" >
              <TextField

                type="number"
                id="Amount"
                name="Amount"
                autoComplete="off"
                value={formData.Amount !== null ? formData.Amount : 0.0}
                onChange={handleChange}
                disabled={!isEditing && addOneButtonEnabled}
                variant="outlined"
                size="small"
                inputProps={{ step: "0.01" }}
                style={{ width: "200px", marginLeft: "-550px" }}
              />
            </FormRow>

            {/* Cheque No */}
            <FormRow label="Cheque No">
              <TextField
                id="chequeno"
                name="cheque_no"
                value={formData.cheque_no || ""}
                onChange={handleChange}
                autoComplete="off"
                variant="outlined"
                disabled={!isEditing && addOneButtonEnabled}
                size="small"
                style={{ width: "340px", marginLeft: "-430px" }}
              />
            </FormRow>

            {/* Narration */}
            <FormRow label="Narration" alignTop>
              <TextField
                id="Narration"
                name="Narration"
                value={formData.Narration || ""}
                onChange={handleChange}
                autoComplete="off"
                variant="outlined"
                disabled={!isEditing && addOneButtonEnabled}
                size="small"
                multiline
                rows={4}
                style={{ width: "340px", marginLeft: "-420px" }}
              />
            </FormRow>

            {/* ── Divider: Cross Company ── */}
            <SectionDivider label="Cross Company Details" />

            {/* Cross Company Code */}
            <FormRow label="Cross Company Code">
              <CompanyMasterHelp
                key={`crossco-${crossResetKey}`}
                onAcCodeClick={handleCrossCompanyCode}
                CompanyName={crosscompanyname}
                CompanyCode={formData.CrossCompany}
                name="CrossCompany"
                Ac_type={[]}
                disabledFeild={!isEditing || isEditMode}
              />
            </FormRow>

            {/* CROSS TO A/c */}
            <FormRow label="CROSS TO Bank Name" style={{ gap: "55px", }}>
              <AccountMasterHelp
                key={`crossto-${crossResetKey}`}
                onAcCodeClick={handlCrossToAccount}
                CategoryName={CrossToName}
                CategoryCode={CrossToCode}
                name="CrossToAcc"
                Ac_type={[]}
                Company_Code={formData.CrossCompany}
                disabledFeild={!isEditing || isEditMode}
              />
            </FormRow>

            {/* CROSS FROM A/c */}
            <FormRow label="CROSS FROM Company Name" style={{ gap: "39px", }}>
              <AccountMasterHelp
                key={`crossfrom-${crossResetKey}`}
                onAcCodeClick={handlCrossFromAccount}
                CategoryName={CrossFromName}
                CategoryCode={CrossFromCode}
                name="CrossFromAcc"
                Ac_type={[]}
                Company_Code={formData.CrossCompany}
                disabledFeild={!isEditing || isEditMode}
              />
            </FormRow>
          </div>
        </form>
      </div>
    </>
  );
};

/* ── Small helper components for consistent row layout ── */

const FormRow = ({ label, children, alignTop = false, style = {} }) => (
  <div
    style={{
      display: "flex",
      alignItems: alignTop ? "flex-start" : "center",
      marginBottom: "14px",
      ...style, // allow custom styles
    }}
  >
    <span
      style={{
        fontSize: "0.8125rem",
        fontWeight: 600,
        color: "#374151",
        minWidth: "50px",
        textAlign: "right",
        paddingTop: alignTop ? "8px" : 0,
        flexShrink: 0,
      }}
    >
      {label}:
    </span>

    <div style={{ flex: 1 }}>{children}</div>
  </div>
);

const SectionDivider = ({ label }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
      margin: "20px 0 16px",
    }}
  >
    <span
      style={{
        fontSize: "0.75rem",
        fontWeight: 700,
        color: "#64748b",
        textTransform: "uppercase",
        letterSpacing: "0.07em",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
    <div style={{ flex: 1, height: "1px", background: "#e2e8f0" }} />
  </div>
);

export default CompanyEntries;